import { __assign, __rest } from "tslib";
import * as React from 'react';
export var BreadcrumbsContext = React.createContext(null);
export function useBreadcrumbsContext() {
    var context = React.useContext(BreadcrumbsContext);
    if (!context) {
        throw new Error('useBreadcrumbsContext must be used within BreadcrumbsContextProvider.');
    }
    return context;
}
export function BreadcrumbsContextProvider(props) {
    var children = props.children, other = __rest(props, ["children"]);
    var context = __assign({}, other);
    return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    React.createElement(BreadcrumbsContext.Provider, { value: __assign({}, context) }, children));
}
export default BreadcrumbsContextProvider;
//# sourceMappingURL=Breadcrumbs.context.js.map